import { useTranslation } from "react-i18next";

import { listConfigActivityTables, type ActivityNode } from "@/api/config-server-stages";
import { listSscuiActivityTables } from "@/api/configuration-server";
import { ConfigActivityModal } from "@/components/agents/configuration-server/ConfigActivityModal";

/** Mantém a origem dos detalhes abertos pelo gerenciamento, inclusive App Fiori. */
export function SscuiActivityModal({ node = "sscui", meta, ...props }: {
  open: boolean;
  onClose: () => void;
  projectId?: string;
  artifactId?: string;
  activityCode: string;
  node?: ActivityNode;
  /** App Fiori: o cabeçalho vem da linha (o endpoint de tabelas só traz tabelas). */
  meta?: {
    name: string | null;
    priority: string | null;
    countries?: string[];
    subarea?: string | null;
    scopeItems?: number;
    /** Execução: os scope items em que a configuração replica, o 8º campo dos detalhes. */
    scopeItemList?: { id: string; name: string | null }[];
  };
}) {
  const { t } = useTranslation();
  const isModule = node === "module_config";
  return (
    <ConfigActivityModal
      {...props}
      meta={isModule ? meta : undefined}
      codeLabel={t(isModule ? "App Fiori configurations" : "SSCUI")}
      queryKey={`sscui-activity-${node}`}
      loadTables={isModule ? async (projectId, activityCode, artifactId) => ({
        ...await listConfigActivityTables(projectId, node, activityCode, artifactId),
        name: null,
        priority: null,
        countries: meta?.countries ?? [],
        application_subarea: meta?.subarea ?? null,
        scope_item_count: meta?.scopeItems,
      }) : listSscuiActivityTables}
      showScope
      scopeItems={meta?.scopeItemList}
      errorLabels={{
        tables: "Could not load extracted tables.",
        records: "Could not load extracted records.",
        retry: "Retry",
      }}
    />
  );
}
